// extracted by mini-css-extract-plugin
module.exports = {"root":"Shutdowns_root__36aUL","wrapper":"Shutdowns_wrapper__tKKTz","header":"Shutdowns_header__1onjV","filterBlock":"Shutdowns_filterBlock__2Vmze","spin":"Shutdowns_spin__2dZ7a"};